module.exports = __webpack_public_path__ + "static/media/icon4.9ea741e1.png";